<template>
  <AdminLayout :title="$t('admin_point.point_manage_title1')" :current="$c.ADMIN.TAB.POINT">
    <Lock @click="chg_lock"></Lock>
    <div class="section">
      <div class="container" align=center style="width:80%">
        <InputSearch style="margin-top: 30px;" :readonly="!state" type="number" v-model="point_num" :placeholder='$t("admin_member.mobile_phone")' @click="do_search(point_num)"></InputSearch>
        <b-form-input style="margin-top: 6px;" :readonly="!state" size="lg" class="admin-border" v-model="point_data" :placeholder='$t("admin_point.point")'></b-form-input>
        <div class="unit leftright" style="margin-top: 19px;">
          <b-button class="butsize" size="lg" variant="none" @click="add_point">{{$t("admin_point.offer")}}</b-button>
          <b-button class="butsize" size="lg" variant="none" @click="del_point">{{$t("admin_point.deduction")}}</b-button>
        </div>
        <div style="margin-top: 30px;">
          <InputSearch :readonly="!state" type="number" v-model="period_num" :placeholder='$t("admin_member.mobile_phone")' @click="do_search(period_num)"></InputSearch>
          <b-form-input :readonly="!state" type="number" size="lg" class="admin-border" v-model="period_data" :placeholder='$t("admin_point.usage_period")'></b-form-input>
          <div class="unit leftright" style="margin-top: 19px;">
            <b-button class="butsize" size="lg" variant="none" @click="add_period">{{$t("admin_point.offer")}}</b-button>
            <b-button class="butsize" size="lg" variant="none" @click="del_period">{{$t("admin_point.deduction")}}</b-button>
          </div>
        </div>
      </div>
    </div>
  </AdminLayout>
</template>
<script>

import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Lock from "./controls/lock";
import Utils from "../../../../config/utils";
const $u = require('util');



export default {
  name: "AdminPoint",
  components: {
    AdminLayout,
    InputSearch,
    Lock,
  },
  data() {
    return {
      state:this.$store.getters.adminLock,
      point_num:"",
      point_data:"",
      period_num:"",
      period_data:"",
    }
  },
  watch:{

  },
  methods:{
    chg_lock(state){
      this.state = state;
    },
    do_search:function (phone) {
      if (this.state)
      Utils.requestGet(this.$c.API.User.findUserByPhone, {
        phone: phone
      }).then(result => {
        if (result.code !== this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, result.msg);
          return;
        }
        Utils.toast(this, $u.format(this.$t('admin.msg_user_find_success'), result.data.f_name));

      });
    },
    add_point: function () {
      if(this.validate('num', this.point_num)){
        if(this.validate('pt_data', this.point_data)){
          Utils.requestGet(this.$c.API.User.findUserByPhone,
            {phone: this.point_num.replaceAll('-', '')}).then(user_result => {
            if (user_result.code !== this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this,user_result.msg);
              return;
            }
            Utils.showConfirm(this,$u.format(this.$t('admin_point.confirm_offer_point'),
              this.point_num.replaceAll('-', ''), user_result.data.f_name, this.point_data)).then(
              value => {
                if(value){
                  Utils.requestPost(
                    this.$c.API.Purchase.addPoint,
                    {
                      user_idx: user_result.data.f_idx,
                      point: this.point_data
                    }
                  ).then(result => {
                    if (result.code === this.$c.API_RES_CODE.SUCCESS) {
                      this.point_data = null;
                      Utils.toast(this,this.$t('admin_point.msg_offer_point_success'));
                    } else {
                      Utils.toast(this,result.msg);
                    }
                  });
                }
              }
            );
          });
        }
      }
    },
    del_point: function () {
      if(this.validate('num', this.point_num)){
        if(this.validate('pt_data', this.point_data)){
          Utils.requestGet(this.$c.API.User.findUserByPhone,
            {phone: this.point_num.replaceAll('-', '')}).then(user_result => {
            if (user_result.code !== this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this,user_result.msg);
              return;
            }
            Utils.showConfirm(this,$u.format(this.$t('admin_point.confirm_deduction_point'),
              this.point_num.replaceAll('-', ''), user_result.data.f_name)).then(
              value => {
                if(value){
                  Utils.requestPost(
                    this.$c.API.Purchase.addPoint,
                    {
                      user_idx: user_result.data.f_idx,
                      point: Math.abs(this.point_data) * -1
                    }
                  ).then(result => {
                    if (result.code === this.$c.API_RES_CODE.SUCCESS) {
                      this.point_data = null;
                      Utils.toast(this,this.$t('admin_point.msg_deduction_point_success'));
                    } else {
                      Utils.toast(this,result.msg);
                    }
                  });
                }
              }
            );
          });
        }
      }
    },
    add_period: function () {
      if(this.validate('num', this.period_num)){
        if(this.validate('pr_data', this.period_data)){
          Utils.requestGet(this.$c.API.User.findUserByPhone,
            {phone: this.period_num.replaceAll('-', '')}).then(user_result => {
            if (user_result.code !== this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this,user_result.msg);
              return;
            }
            Utils.showConfirm(this,$u.format(this.$t('admin_point.confirm_offer_period'),
              this.period_num.replaceAll('-', ''),user_result.data.f_name,this.period_data)).then(
              value => {
                if(value){
                  Utils.requestPost(
                    this.$c.API.Purchase.addPeriod,
                    {
                      user_idx: user_result.data.f_idx,
                      period: this.period_data
                    }
                  ).then(result => {
                    if (result.code === this.$c.API_RES_CODE.SUCCESS) {
                      this.period_data = null;
                      Utils.toast(this,this.$t('admin_point.msg_offer_period_success'));
                    } else {
                      Utils.toast(this,result.msg);
                    }
                  });
                }
              }
            );
          })
        }
      }
    },
    del_period: function () {
      if(this.validate('num', this.period_num)){
        if(this.validate('pr_data', this.period_data)){
          Utils.requestGet(this.$c.API.User.findUserByPhone,
            {phone: this.period_num.replaceAll('-', '')}).then(user_result => {
            if (user_result.code !== this.$c.API_RES_CODE.SUCCESS) {
              Utils.toast(this,user_result.msg);
              return;
            }
            Utils.showConfirm(this,$u.format(this.$t('admin_point.confirm_deduction_period'),
              this.period_num.replaceAll('-', ''),user_result.data.f_name, this.period_data)).then(
              value => {
                if(value){
                  Utils.requestPost(
                    this.$c.API.Purchase.addPeriod,
                    {
                      user_idx: user_result.data.f_idx,
                      period: Math.abs(this.period_data) * -1
                    }
                  ).then(result => {
                    if (result.code === this.$c.API_RES_CODE.SUCCESS) {
                      this.period_data = null;
                      Utils.toast(this,this.$t('admin_point.msg_deduction_period_success'));
                    } else {
                      Utils.toast(this,result.msg);
                    }
                  });
                }
              }
            );
          })

        }
      }
    },
    validate(type, data){
      if(this.state){
        if (data !== ""){
          return true;
        }else{
          var toast_str = "";
          switch (type){
            case 'num': toast_str = this.$t('login.phone_placeholder'); break;
            case 'pt_data': toast_str = this.$t('admin_point.point_placeholder'); break;
            case 'pr_data': toast_str = this.$t('admin_point.period_placeholder'); break;
          }
          Utils.toast(this, toast_str);
          return false;
        }
      }else{
        Utils.toast(this, this.$t('admin.unlock_hint'));

      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
@import '../../../../assets/css/_vars.scss';

.butsize {
  width:48%;
  border-radius: 0;
  font-size: 16px;
  font-family: $korean_gd_15_r;
  height: 45px;
  background-color: #267fff;
  color: white;
}

input {
  text-align: center;
  margin-top:0.3em;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}

.unit{
  margin-top:1em;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminPoint.vue